// Definisikan tipe Field dengan tipe generik T
export interface Field<T> {
    label: string;
    name: keyof T;
    dataType: string;
  }
  
  // Fungsi untuk membuat array field form generik
  export const createRequestFields = <T>(fields: Field<T>[]): Field<T>[] => {
    return fields;
  };
  
  // Fungsi untuk membuat data form awal generik
  export const createInitialFormData = <T>(fields: Field<T>[]): T => {
    return fields.reduce((acc, field) => {
      acc[field.name] = '' as any;
      return acc;
    }, {} as T);
  };
  
  // defisini updateAdd props
  export interface AddUpdateModalProps<T> {
    open: boolean;
    onClose: () => void;
    onSubmit: (data: T) => void;
    isEdit: boolean;
    title: string;
    data?: T;
    fields: Field<T>[];
    initialData: T;
}